<template>
    <div class="card">
        <div class="card-content">
            <div class="content">
                <header>
                    <tr-text class="column" v-bind="props.headline" :tracker="tracker"
                            @edit-tr="$emit('edit-tr', $event)" />
                </header>
                <component :is="child.tag" v-for="(child, idx) in children" :key="idx"
                    v-bind="child"
                    :index="idx"
                    :tracker="tracker"
                    @edit-tr="$emit('edit-tr', $event)"
                ></component>
            </div>
        </div>
    </div>
</template>

<script>
import TrText               from "@/components/translation/TrText"
import I18nText             from "@/components/i18n/I18nText"

export default {
    name: "I18nTooltip",
    components: {TrText, I18nText},
    props: {
        tracker: Array,
        index: Number,
        children: Array,
        props: Object,
        showLabel: {default: true}
    }
}
</script>

<style scoped>
    .content header {
        border-bottom: 1px solid black;
        font-size:      1.8em;
        font-weight:    bold;
    }
    .content {
        padding: 0;
    }
</style>